import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { getProductAvailability } from "@/api/product/getProductAvailability";

export function ProductAvailabilityList() {
  const query = getProductAvailability.useQuery();

  if (query.isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (query.isError) {
    return (
      <Alert severity="error">
        Failed to load product availability: {JSON.stringify(query.error)}
      </Alert>
    );
  }

  const rows = query.data ?? [];

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: "calc(100vh - 160px)" }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Location</TableCell>
            <TableCell align="right">On Hand</TableCell>
            <TableCell align="right">Allocated</TableCell>
            <TableCell align="right">Available</TableCell>
            <TableCell align="right">On Order</TableCell>
            <TableCell align="right">In Transit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={`${row.ID}-${row.Location}`} hover>
              <TableCell sx={{ fontFamily: "monospace" }}>{row.ID}</TableCell>
              <TableCell>{row.SKU}</TableCell>
              <TableCell>{row.Name}</TableCell>
              <TableCell>{row.Location}</TableCell>
              <TableCell align="right">{row.OnHand}</TableCell>
              <TableCell align="right">{row.Allocated}</TableCell>
              <TableCell align="right">{row.Available}</TableCell>
              <TableCell align="right">{row.OnOrder}</TableCell>
              <TableCell align="right">{row.InTransit}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
